export default __webpack_public_path__ + "static/media/bannerDAD_AUS.f66b2a76.jpg";